import { plainToClass } from 'class-transformer';
import {
  API_REFERRAL_TYPE_CREATE,
  API_REFERRAL_TYPE_DELETE,
  API_REFERRAL_TYPE_FIND_ALL,
  API_REFERRAL_TYPE_FIND_ONE,
  API_REFERRAL_TYPE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { ReferralTypeDto } from '../dto';
import { FindAllResponse } from '../types';

export class ReferralTypeApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ReferralTypeDto>> {
    return this.httpClient
      .get(API_REFERRAL_TYPE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ReferralTypeDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ReferralTypeDto> {
    return this.httpClient
      .get(API_REFERRAL_TYPE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ReferralTypeDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ReferralTypeDto> {
    return this.httpClient
      .post(API_REFERRAL_TYPE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ReferralTypeDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ReferralTypeDto> {
    return this.httpClient
      .put(API_REFERRAL_TYPE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ReferralTypeDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_REFERRAL_TYPE_DELETE, {
      pathParams: { uuid }
    });
  }
}
